import { useCallback } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useRoomIsDormitoryType } from "./hooks";

export const QuestionRoomIsDormitory = () => {
	const { isDormitoryType, onSetIsDormitoryType: _onSetIsDormitoryType } = useRoomIsDormitoryType();

	const onSetIsDormitoryType = useCallback(
		(value: boolean) => {
			_onSetIsDormitoryType(value);
		},
		[_onSetIsDormitoryType],
	);

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"ドミトリータイプ"}
			isEdited={isDormitoryType.isEdited}
			hasError={Boolean(isDormitoryType.error)}
			guide="ドミトリータイプの部屋に設定すると、部屋の利用人数が消費される在庫として扱われます。 お子様も一つのベッドを利用するものとして在庫の管理がされます。"
			inputChildren={
				<CheckboxField
					value={isDormitoryType.value}
					label={"ドミトリータイプに指定する"}
					handleChange={onSetIsDormitoryType}
					errorMessage={isDormitoryType.error}
				/>
			}
		/>
	);
};

QuestionRoomIsDormitory.displayName = "QuestionRoomIsDormitory";
